import { Component, Vue } from 'vue-property-decorator'

@Component
export default class UstraComponent extends Vue {
  /**
   * 페이지 컴포넌트 여부
   */
  _isPageComponent: boolean = false

  created() {

    if (!this.$ustra) {
      return
    }

    // 현재 컴포넌트가 페이지 컴포넌트인지 확인
    this._isPageComponent = this.$ustra.utils.component.isPageComponent(this)
  }

  private requiredBlockCopy() {
    return !!this.$options.config?.ui?.blockCopy
  }

  mounted() {
    if (this.requiredBlockCopy()) {
      this.$ustra.utils.browser.startBlockCopy()
    }
  }

  activated() {
    if (this.requiredBlockCopy()) {
      this.$ustra.utils.browser.startBlockCopy()
    }
  }

  beforeDestroy() {
    this.$ustra.utils.browser.stopBlockCopy()
  }

  deactivated() {
    this.$ustra.utils.browser.stopBlockCopy()
  }
}

export { UstraComponent }
